import { AppNS } from 'app';
import { compact } from 'lodash-es';

import { isClient } from './userRoles';

export const can = (user: AppNS.User | undefined, action: AppNS.Permission, companyId?: string): boolean => {
  if (!user) {
    return false;
  }

  // If user is a client, and does not have any employments, they can perform any action
  if (isClient(user) && (!user.employments || user.employments.length === 0)) {
    return true;
  }

  return hasPermissions(user.employments, action, companyId);
};

export const hasPermissions = (
  employments: AppNS.Employment[],
  action: AppNS.Permission,
  companyId?: string
): boolean => {
  if (employments.length === 0) {
    return false;
  }

  // If there is only one employment, default companyId is the first employment's companyId
  if (employments.length === 1) {
    return hasPermissionsInCompany(employments[0], action);
  }

  // If companyId is provided, check if the user has permissions in that specific company
  if (companyId && employments.length > 1) {
    return hasPermissionsInCompany(
      employments.find((item: AppNS.Employment) => item.companyId === companyId),
      action
    );
  }

  // ???
  return employments.some((item: AppNS.Employment) => hasPermissionsInCompany(item, action));
};

export const hasPermissionsInCompany = (
  employment: AppNS.Employment | undefined,
  action: AppNS.Permission
): boolean => {
  if (!employment) {
    return false;
  }
  return employment.permissions.includes(action);
};

export const companiesWithPermission = (user: AppNS.User | undefined, action: AppNS.Permission): AppNS.Company[] => {
  if (!user) {
    return [];
  }

  return compact(
    user.employments.map((item: AppNS.Employment) =>
      item.permissions.includes(action) || action === 'any' ? item.company : null
    )
  );
};
